/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import openWindowIcon from '~img/openWindow.png'
import * as s from './CardCTA.module.scss'

const CardCTA = ({ icon, title, url, featured }) => {
  const { t } = useTranslation()

  const handleOnClick = () => {
    window.open(url, '_blank')
  }

  return (
    <div className={s.cardCTA} onClick={handleOnClick}>
      <img className={s.icon} src={icon} alt="icon" />
      <span>{title}</span>
      {featured && <span className={s.recommended}>{t('recommended')}</span>}
      <img className={s.redirect} src={openWindowIcon} alt="open" />
    </div>
  )
}

export default CardCTA
